export const parseProductCode = (
  code = ''
): { productCode: string; productVersion: string } => {
  const [productCode, productVersion = ''] = code.split(',');
  return { productCode, productVersion };
};
